import React from 'react';
import { Multi } from './Multi';
import { Single } from './Single';
import { ISelect } from './types';

// TODO: support live search
const Select = ({ multiple, ...rest }: ISelect) => {
  if (multiple) {
    return <Multi {...rest} />;
  }

  return <Single {...rest} />;
};

export { Select };
